import { GlobalState } from 'reducers';

export const getCases = (state: GlobalState) => state.cases.normalized;
